/* BROSMARBLE — UI/UX refinement layer (2026-08-31). Progressive enhancement only. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Collection description: clamp + read more ---------------- */
  function initCollectionDescription() {
    var el = document.querySelector('.collection-hero__description');
    if (!el || el.dataset.brmClamp) return;
    // Only clamp when there is meaningfully more copy than the clamp height.
    var full = el.scrollHeight;
    var limit = window.matchMedia('(max-width: 749px)').matches ? 90 : 96;
    if (full <= limit + 40) return;

    el.dataset.brmClamp = '1';
    el.classList.add('brm-clamp');
    el.id = el.id || 'brm-collection-description';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'brm-readmore';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', el.id);
    var label = document.createElement('span');
    label.textContent = 'Read more';
    btn.appendChild(label);
    btn.insertAdjacentHTML(
      'beforeend',
      '<svg viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.4"/></svg>'
    );
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = open ? 'Read less' : 'Read more';
      if (!open) {
        var top = el.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      }
    });
    el.insertAdjacentElement('afterend', btn);
  }

  /* ---------- 2. Article table of contents -------------------------------- */
  function slug(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }

  function initArticleToc() {
    var content = document.querySelector('.article-template__content');
    if (!content || content.dataset.brmToc) return;
    var heads = Array.prototype.slice
      .call(content.querySelectorAll('h2'))
      .filter(function (h) { return h.textContent.trim().length > 2 && !h.closest('.brm-ashop, .brm-afaq'); });
    if (heads.length < 4) return;
    content.dataset.brmToc = '1';

    var used = {};
    var items = heads.map(function (h) {
      var id = h.id;
      if (!id) {
        id = slug(h.textContent);
        if (used[id]) { id = id + '-' + (++used[id]); } else { used[id] = 1; }
        h.id = id;
      }
      return { id: id, text: h.textContent.trim() };
    });

    var listHtml = items
      .map(function (i) {
        return '<li><a href="#' + i.id + '">' + i.text.replace(/[<>&]/g, '') + '</a></li>';
      })
      .join('');

    var host = document.createElement('nav');
    host.className = 'brm-toc page-width page-width--narrow';
    host.setAttribute('aria-label', 'In this article');
    host.innerHTML =
      '<details class="brm-toc__details"><summary class="brm-toc__title">In this article</summary>' +
      '<ol class="brm-toc__list">' + listHtml + '</ol></details>';

    var header = document.querySelector('.article-template header.page-width');
    if (header) header.insertAdjacentElement('afterend', host);
    else content.insertAdjacentElement('beforebegin', host);

    // Open by default on wide screens where the rail sits in the margin.
    var wide = window.matchMedia('(min-width: 1200px)');
    var details = host.querySelector('details');
    function sync() { details.open = wide.matches; }
    sync();
    if (wide.addEventListener) wide.addEventListener('change', sync);

    // Scrollspy
    if ('IntersectionObserver' in window) {
      var links = {};
      host.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            var a = links[e.target.id];
            if (!a) return;
            if (e.isIntersecting) {
              host.querySelectorAll('a.is-current').forEach(function (x) { x.classList.remove('is-current'); });
              a.classList.add('is-current');
            }
          });
        },
        { rootMargin: '-15% 0px -70% 0px' }
      );
      heads.forEach(function (h) { io.observe(h); });
    }
  }

  /* ---------- 3. Review carousel: name the product each review is about ---- */
  function initReviewProductNames() {
    var items = document.querySelectorAll('.jdgm-carousel-item__product');
    if (!items.length) return false;
    var done = 0;
    Array.prototype.forEach.call(items, function (wrap) {
      if (wrap.dataset.brmNamed) { done++; return; }
      var img = wrap.querySelector('img');
      var name = img && (img.getAttribute('alt') || '').trim();
      if (!name) return;
      wrap.dataset.brmNamed = '1';
      var span = document.createElement('span');
      span.className = 'brm-jdgm-pname';
      span.textContent = name;
      wrap.appendChild(span);
      done++;
    });
    return done === items.length;
  }

  function watchReviewCarousel() {
    if (initReviewProductNames()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (initReviewProductNames() || tries > 40) clearInterval(timer);
    }, 500);
  }

  function boot() {
    try { initCollectionDescription(); } catch (e) {}
    try { initArticleToc(); } catch (e) {}
    try { watchReviewCarousel(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();


/* ==========================================================================
   PDP · put the reassurance strip directly under the buy buttons
   The strip is rendered by brm-trust-block.liquid further down the column.
   Moving our OWN node (never a theme node) into the form keeps the last thing
   the eye passes before the click a reason to click, and leaves the fuller
   trust list in place lower down for people who read on.
   ========================================================================== */
(function () {
  function placeAssure() {
    var strip = document.querySelector('[data-brm-assure]');
    if (!strip || strip.dataset.brmPlaced === '1') return;
    var buttons = document.querySelector('.product__info-container .product-form__buttons');
    if (!buttons || !buttons.parentNode) return;
    buttons.parentNode.insertBefore(strip, buttons.nextSibling);
    strip.dataset.brmPlaced = '1';
    strip.classList.add('brm-atc-assure--placed');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeAssure);
  } else {
    placeAssure();
  }
  document.addEventListener('shopify:section:load', placeAssure);
})();
